import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/student',
  component: Layout,
  name: 'studentManagement',
  meta: {
    title: '学员管理',
    icon: 'i-ep:user-filled',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'studentList',
      component: () => import('@/views/student/index.vue'),
      meta: {
        title: '用户列表',
        icon: 'i-ep:user',
      },
    },
  ],
}

export default routes
